export default "__VITE_PUBLIC_ASSET__87593eea__"